(() => {
  const bodySelector =
    "body.sa-com.sa-com-v6:is(.sa-com-template-eden, .sa-com-template-stadium-premium)";
  const selector =
    `${bodySelector} product-info.sa-pdp-v9[data-sa-pdp-product] [data-sa-pdp-v14-proof]`;

  function initProof(root) {
    if (!root || root.dataset.saPdpV14Ready === "true") return;

    const slides = [...root.querySelectorAll("[data-sa-pdp-v14-slide]")];
    const progress = root.querySelector("[data-sa-pdp-v14-progress]");
    if (slides.length < 2 || !progress) return;

    root.dataset.saPdpV14Ready = "true";

    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");
    let current = Math.max(
      0,
      slides.findIndex((slide) => slide.classList.contains("is-active"))
    );
    let timer = 0;
    let isInView = !("IntersectionObserver" in window);
    let isHovered = false;
    let hasKeyboardFocus = root.matches(":focus-visible");

    const clearTimer = () => {
      if (timer) {
        window.clearInterval(timer);
        timer = 0;
      }
    };

    const stop = () => {
      clearTimer();
      root.classList.remove("is-progressing", "is-user-paused");
    };

    const restartProgress = () => {
      root.classList.remove("is-progressing");
      void root.offsetWidth;
      root.classList.add("is-progressing");
    };

    const show = (nextIndex) => {
      current = (nextIndex + slides.length) % slides.length;
      slides.forEach((slide, index) => {
        const isActive = index === current;
        slide.classList.toggle("is-active", isActive);
        slide.setAttribute("aria-hidden", isActive ? "false" : "true");
      });
    };

    const start = () => {
      clearTimer();
      if (reducedMotion.matches || document.hidden || !isInView) {
        stop();
        return;
      }
      // Keep the progress visible while someone reads with a mouse or keyboard.
      // A touch/click focus is not a pause: mobile browsers can retain it indefinitely.
      if (isHovered || hasKeyboardFocus) {
        root.classList.add("is-user-paused");
        if (!root.classList.contains("is-progressing")) restartProgress();
        return;
      }
      root.classList.remove("is-user-paused");
      restartProgress();
      timer = window.setInterval(() => {
        show(current + 1);
        restartProgress();
      }, 3000);
    };

    root.addEventListener("pointerenter", (event) => {
      if (event.pointerType === "touch") return;
      isHovered = true;
      start();
    });
    root.addEventListener("pointerleave", (event) => {
      if (event.pointerType === "touch") return;
      isHovered = false;
      start();
    });
    root.addEventListener("focusin", () => {
      hasKeyboardFocus = root.matches(":focus-visible");
      start();
    });
    root.addEventListener("focusout", () => {
      hasKeyboardFocus = false;
      start();
    });
    root.addEventListener("pointerdown", () => {
      hasKeyboardFocus = false;
      start();
    });

    document.addEventListener("visibilitychange", () => {
      if (document.hidden) stop();
      else start();
    });

    if (typeof reducedMotion.addEventListener === "function") {
      reducedMotion.addEventListener("change", start);
    }

    const hasIntersectionObserver = "IntersectionObserver" in window;

    if (hasIntersectionObserver) {
      const observer = new IntersectionObserver(
        ([entry]) => {
          isInView = entry.isIntersecting;
          if (isInView) start();
          else stop();
        },
        { threshold: 0.15 }
      );
      observer.observe(root);
    }

    show(current);
    if (!hasIntersectionObserver) start();
  }

  const initAll = () => {
    document.querySelectorAll(selector).forEach(initProof);
    if (window.matchMedia('(max-width: 749px)').matches) {
      document.querySelectorAll(`${bodySelector} .sa-pdp-v15__timeline details[open]`).forEach((item) => {
        item.removeAttribute('open');
      });
    }
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initAll, { once: true });
  } else {
    initAll();
  }

  document.addEventListener("shopify:section:load", initAll);
})();
